import React from 'react';
import OlxPeople from '../Components/InfoPages/OlxPeople';

function PeoplePage() {
  return <OlxPeople />;
}

export default PeoplePage;
